import http from './http';

export async function downloadFile(url: string, filename?: string) {
  return http
    .get(url, {
      responseType: 'blob',
    })
    .then(({ data }) => {
      const url = URL.createObjectURL(data as Blob);

      const a = document.createElement('a');
      a.href = url;
      a.download = `${filename}`;
      document.body.appendChild(a);
      a.click();

      setTimeout(() => {
        URL.revokeObjectURL(url);
        document.body.removeChild(a);
      }, 100);
    });
}
